import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/main.css'
import printEventService from './services/printEventService'

const app = createApp(App)

app.use(store)
app.use(router)

store.dispatch('auth/restoreAuth')

app.mount('#app')

router.beforeEach((to, from, next) => {
  if (to.name === 'Login') {
    // ログイン画面に遷移する際に印刷イベントサービスを切断
    console.log('User is not authenticated. Disconnecting print event service.')
    sessionStorage.removeItem('printButtonEnabled');
    printEventService.disconnect();
  }
  next();
});
